import { eventStore, syncQueue, idMapStore } from '../indexedDBService'
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export async function syncEvents() {
	const keys = await syncQueue.keys()

	for (const key of keys) {
		const action = await syncQueue.getItem(key)
		if (!action || !action.type) continue

		try {
			const payload = { ...action.payload }

			// --- Alta (nacimiento o adquisición) ---
			if (action.type === 'EVENT_BIRTH_ADD_OFFLINE' || action.type === 'EVENT_ACQUISITION_ADD_OFFLINE') {
				try {
					const { status } = await Axios.post('/api/event/register/alta', payload, {
						headers: { auth: localStorage.getItem('jwt') }
					})

					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn(`Error al sincronizar alta (${payload.type}):`, error)
				}
			}

			// --- Editar Alta ---
			if (action.type === 'EVENT_BIRTH_EDIT_OFFLINE' || action.type === 'EVENT_ACQUISITION_EDIT_OFFLINE') {
				try {
					const { id, type, payload: data } = payload
					const { status } = await Axios.put(`/api/event/${id}`, { type, payload: data }, {
						headers: { auth: localStorage.getItem('jwt') }
					})

					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn(`Error al sincronizar edición de alta (${payload.type}):`, error)
				}
			}

			// --- Baja (death, sacrifice, desvieje, sale) ---
			if (
				action.type === 'EVENT_DEATH_ADD_OFFLINE' ||
				action.type === 'EVENT_SACRIFICE_ADD_OFFLINE' ||
				action.type === 'EVENT_DESVIEJE_ADD_OFFLINE' ||
				action.type === 'EVENT_SALE_ADD_OFFLINE'
			) {
				try {
					const { status } = await Axios.post('/api/event/register/baja', payload, {
						headers: { auth: localStorage.getItem('jwt') }
					})

					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn(`Error al sincronizar evento baja (${payload.type}):`, error)
				}
			}

			// --- Editar Baja ---
			if (
				action.type === 'EVENT_DEATH_EDIT_OFFLINE' ||
				action.type === 'EVENT_SACRIFICE_EDIT_OFFLINE' ||
				action.type === 'EVENT_DESVIEJE_EDIT_OFFLINE' ||
				action.type === 'EVENT_SALE_EDIT_OFFLINE'
			) {
				try {
					const { id, type, payload: data } = payload
					const { status } = await Axios.put(`/api/event/${id}`, { type, ...data }, {
						headers: { auth: localStorage.getItem('jwt') }
					})

					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn(`Error al sincronizar edición de baja (${payload.type}):`, error)
				}
			}

			// --- Movimiento OFFLINE ---
			if (action.type === 'EVENT_MOVEMENT_ADD_OFFLINE') {
				try {
					const { status } = await Axios.post('/api/event/register/movement', payload, {
						headers: { auth: localStorage.getItem('jwt') }
					})

					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn('Error al sincronizar evento de movimiento:', error)
				}
			}

			// --- Editar Movimiento ---
			if (action.type === 'EVENT_MOVEMENT_EDIT_OFFLINE') {
				try {
					const { id, type, ...data } = payload
					const { status } = await Axios.put(`/api/event/${id}`, { type, ...data }, {
						headers: { auth: localStorage.getItem('jwt') }
					})

					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn('Error al sincronizar edición de evento de movimiento:', error)
				}
			}

			// --- Revisión OFFLINE ---
			if (action.type === 'EVENT_REVIEW_ADD_OFFLINE') {
				try {
					const { status } = await Axios.post('/api/event/register/review', payload, {
						headers: { auth: localStorage.getItem('jwt') }
					})

					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn('Error al sincronizar evento de revisión:', error)
				}
			}

			// --- Editar revisión ---
			if (action.type === 'EVENT_REVIEW_EDIT_OFFLINE') {
				try {
					const { id, type, ...data } = payload
					const { status } = await Axios.put(`/api/event/${id}`, { type, ...data }, {
						headers: { auth: localStorage.getItem('jwt') }
					})

					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn('Error al sincronizar edición de revisión:', error)
				}
			}

			// --- Para revisar OFFLINE ---
			if (
				action.type === 'EVENT_REVIEWMARK_ADD_OFFLINE' ||
				action.type === 'EVENT_STATUS_ADD_OFFLINE' ||
				action.type === 'EVENT_HEAT_ADD_OFFLINE'
			) {
				try {
					const { status } = await Axios.post('/api/event/register/simple', payload, {
						headers: { auth: localStorage.getItem('jwt') }
					})
					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn(`Error al sincronizar evento ${payload.type}:`, error)
				}
			}

			// --- Editar para revisar ---
			if (
				action.type === 'EVENT_REVIEWMARK_EDIT_OFFLINE' ||
				action.type === 'EVENT_STATUS_EDIT_OFFLINE' ||
				action.type === 'EVENT_HEAT_EDIT_OFFLINE'
			) {
				try {
					const { id, type, ...data } = payload
					const { status } = await Axios.put(`/api/event/${id}`, { type, ...data }, {
						headers: { auth: localStorage.getItem('jwt') }
					})
					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn(`Error al sincronizar edición de ${payload.type}:`, error)
				}
			}

			// --- Parto OFFLINE ---
			if (action.type === 'EVENT_BIRTHPROCESS_ADD_OFFLINE') {
				try {
					const { status } = await Axios.post('/api/event/register/birthProcess', payload, {
						headers: { auth: localStorage.getItem('jwt') }
					})

					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn('Error al sincronizar evento de parto:', error)
				}
			}

			// --- Editar parto ---
			if (action.type === 'EVENT_BIRTHPROCESS_EDIT_OFFLINE') {
				try {
					const { id, type, ...data } = payload
					const { status } = await Axios.put(`/api/event/${id}`, { type, ...data }, {
						headers: { auth: localStorage.getItem('jwt') }
					})
					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn('Error al sincronizar edición de evento parto:', error)
				}
			}

			// --- Aborto OFFLINE ---
			if (action.type === 'EVENT_ABORT_ADD_OFFLINE') {
				try {
					const { status } = await Axios.post('/api/event/register/aborto', payload, {
						headers: { auth: localStorage.getItem('jwt') }
					})
					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn('Error al sincronizar aborto (add):', error)
				}
			}

			// --- Editar aborto ---
			if (action.type === 'EVENT_ABORT_EDIT_OFFLINE') {
				try {
					const { id, type, ...data } = payload
					const { status } = await Axios.put(`/api/event/${id}`, { type, ...data }, {
						headers: { auth: localStorage.getItem('jwt') }
					})
					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn('Error al sincronizar aborto (edit):', error)
				}
			}

			// --- Destete OFFLINE ---
			if (action.type === 'EVENT_WEANING_ADD_OFFLINE') {
				try {
					const { status } = await Axios.post('/api/event/register/weaning', payload, {
						headers: { auth: localStorage.getItem('jwt') }
					})
					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn('Error al sincronizar destete (add):', error)
				}
			}

			// --- Editar destete ---
			if (action.type === 'EVENT_WEANING_EDIT_OFFLINE') {
				try {
					const { id, type, ...data } = payload
					const { status } = await Axios.put(`/api/event/${id}`, { type, ...data }, {
						headers: { auth: localStorage.getItem('jwt') }
					})
					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn('Error al sincronizar destete (edit):', error)
				}
			}

			// --- Pesaje OFFLINE ---
			if (action.type === 'EVENT_WEIGHT_ADD_OFFLINE') {
				try {
					const { status } = await Axios.post('/api/event/register/weight', payload, {
						headers: { auth: localStorage.getItem('jwt') }
					})
					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn('Error al sincronizar pesaje (add):', error)
				}
			}

			// --- Editar pesaje ---
			if (action.type === 'EVENT_WEIGHT_EDIT_OFFLINE') {
				try {
					const { id, type, ...data } = payload
					const { status } = await Axios.put(`/api/event/${id}`, { type, ...data }, {
						headers: { auth: localStorage.getItem('jwt') }
					})
					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn('Error al sincronizar pesaje (edit):', error)
				}
			}

			// --- Inseminación OFFLINE ---
			if (action.type === 'EVENT_INSEMINATION_ADD_OFFLINE') {
				try {
					const { status } = await Axios.post('/api/event/register/insemination', payload, {
						headers: { auth: localStorage.getItem('jwt') }
					})
					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn('Error al sincronizar inseminación (add):', error)
				}
			}

			// --- Editar inseminación ---
			if (action.type === 'EVENT_INSEMINATION_EDIT_OFFLINE') {
				try {
					const { id, type, ...data } = payload
					const { status } = await Axios.put(`/api/event/${id}`, { type, ...data }, {
						headers: { auth: localStorage.getItem('jwt') }
					})
					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn('Error al sincronizar inseminación (edit):', error)
				}
			}

			// --- Semental OFFLINE ---
			if (action.type === 'EVENT_SEMENTAL_ADD_OFFLINE') {
				try {
					const { status } = await Axios.post('/api/event/register/semental', payload, {
						headers: { auth: localStorage.getItem('jwt') }
					})
					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn('Error al sincronizar semental (add):', error)
				}
			}

			// --- Editar semental ---
			if (action.type === 'EVENT_SEMENTAL_EDIT_OFFLINE') {
				try {
					const { id, type, ...data } = payload
					const { status } = await Axios.put(`/api/event/${id}`, { type, ...data }, {
						headers: { auth: localStorage.getItem('jwt') }
					})
					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (error) {
					console.warn('Error al sincronizar semental (edit):', error)
				}
			}

			// --- Estado OFFLINE ---
			if (action.type === 'EVENT_STATUS_ADD_OFFLINE') {
				try {
					const { status } = await Axios.post('/api/event/register/status', payload, {
						headers: { auth: localStorage.getItem('jwt') }
					})
					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (e) {
					console.warn('Error sincronizando estado:', e)
				}
			}

			// --- Editar estado ---
			if (action.type === 'EVENT_STATUS_EDIT_OFFLINE') {
				try {
					const { id, type, ...data } = payload
					const { status } = await Axios.put(`/api/event/${id}`, { type, ...data }, {
						headers: { auth: localStorage.getItem('jwt') }
					})
					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (err) {
					console.warn('Error al sincronizar edición estado:', err)
				}
			}

			// --- Heat OFFLINE ---
			if (action.type === 'EVENT_HEAT_ADD_OFFLINE') {
				try {
					const { status } = await Axios.post('/api/event/register/heat', payload, {
						headers: { auth: localStorage.getItem('jwt') }
					})
					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (e) {
					console.warn('Error sincronizando heat:', e)
				}
			}

			// --- Editar celo ---
			if (action.type === 'EVENT_HEAT_EDIT_OFFLINE') {
				try {
					const { id, type, ...data } = payload
					const { status } = await Axios.put(`/api/event/${id}`, { type, ...data }, {
						headers: { auth: localStorage.getItem('jwt') }
					})
					if (status === 200) {
						await syncQueue.removeItem(key)
						await eventStore.removeItem(key)
					}
				} catch (err) {
					console.warn('Error al sincronizar edición celo:', err)
				}
			}
		} catch (error) {
			console.warn(`Error al procesar acción offline (${action?.type}):`, error)
		}
	}
}
